import { gql } from '@apollo/client';

export const GET_MARKET_INDICATORS = gql`
  query GetMarketIndicators {
    marketIndicators {
      altcoinSeasonScore
      altcoinSeasonStatus
      btcDominance
      fearAndGreedScore
      fearAndGreedStatus
      marketCap
      marketCapChange24h
    }
  }
`; 